module.exports = __webpack_public_path__ + "assets/img/11.d6c20a93.png";